import { Modal, AsyncSelect } from "components";
import { Button } from "expano-components";
import { useState } from "react";

import getRootTaxonOptions from "utils/select_options/getRootTaxonOptions";

const AddProductFromCategory = ({ handleClose, handleConfirm }) => {
  const [product_ids, setProductIds] = useState([null]);
  return (
    <Modal
      size="md"
      handleClose={handleClose}
      header={{
        title: "Dodaj produkty z kategorii",
      }}
      footer={
        <>
          <Button type="cancel" onClick={handleClose} />
          <Button
            type="add-green"
            disabled={!product_ids.length}
            text="Dodaj"
            onClick={() => handleConfirm(product_ids)}
          />
        </>
      }
    >
      <AsyncSelect
        label="Wybierz kategorię, z której produkty chcesz dodać do kampanii"
        getData={(q) => getRootTaxonOptions(q)}
        onChange={(item) => setProductIds(item.product_ids)}
      />
    </Modal>
  );
};

export default AddProductFromCategory;
